import type { EFolderType, TSparseItem } from '@modules/items/types/folders.types';
import type { AccessType, TPermissions } from '@modules/access/types';
import type { TBaseStats } from '@shared/types/stats.types';

export type TProjectRootItemType = EFolderType.QM | EFolderType.PRODUCT | EFolderType.COUNTRY;
export enum EProjectStatus {
  PLANNING = 'PLANNING',
  ACTIVE = 'ACTIVE',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
}
export enum EProjectView {
  TASKS = 'tasks',
  DASHBOARD = 'dashboard',
}
export type TProject = TSparseItem & {
  organization: string;
  parent: string;
  leads: string[];
  members: string[];
  status: EProjectStatus;
  archived: boolean;
  active: boolean;
  stats: TBaseStats;
  description?: string;
  /** Calendar dates serialized at UTC midnight, as with periodic reviews. */
  startDate?: string;
  dueDate?: string;
};
export type TProjectFormValues = Pick<TProject, 'name' | 'leads' | 'members'> & {
  description: string;
  /** Selected calendar days (YYYY-MM-DD), or null to clear. */
  startDate: string | null;
  dueDate: string | null;
};
export type TProjectListItem = Pick<TProject, '_id' | 'name' | 'status' | 'leads' | 'startDate' | 'dueDate'> & {
  accessRight: AccessType;
};
export type TProjectList = {
  items: TProjectListItem[];
  total: number;
};
export type TProjectDetails = { project: TProject; permissions: Pick<TPermissions, 'accessRight'> };
export type TProjectListParams = {
  parent: string;
  page: number;
  pageSize: number;
  search: string;
  status: EProjectStatus[];
};

export type TUpdateProjectDetails = Partial<Omit<TProjectFormValues, 'description'>> & { description?: string | null };
